import React, {Component} from 'react';
import ReactGA from 'react-ga4';
import BraintreeDropin from './BraintreeDropin'
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import InfoBar from './InfoBar';
import BlikForm from './BlikForm';
import Przelewy24Form from './Przelewy24Form';
import {withStyles} from '@material-ui/core/styles';
import {withTranslation} from 'react-i18next';
import blik_logo from './blik-logo.png'
import p24_logo from './Przelewy24_logo.svg'
import paypal_logo from './paypal.svg'
import CardContent from "@material-ui/core/CardContent/CardContent";

const styles = {
    root: {
        marginTop: '20px',
    }
};

class PaymentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {state: 'loading', btToken: null, language: 'en'};
        props.i18n.on('languageChanged', this.updateLanguage);
    }

    updateLanguage = () => {
        this.setState({language: this.state.language})
    }

    render() {
        const {className, classes, t} = this.props;

        if (this.props.paymentCompleted) {
            return (
                <>
                    <InfoBar
                        caption={t('paymentCompleted')}
                        type="success"/>
                </>
            )
        }

        if (this.state.state === 'processing') {
            return (
                <InfoBar
                    caption={t('paymentProcessing')}
                    type="info"/>
            )
        }

        return (
            <div>
                {this.props.paymentMethods?.includes('blik') &&
                    <Card className={classNames(classes.root, className)}>
                        <CardContent>
                            <BlikForm
                                paymentStatus={this.props.paymentStatus}
                                onPaymentCompleted={this.props.onPaymentCompleted}
                                submitUrl={this.props.blikSubmitUrl}
                                disabled={this.props.disabled || this.state === 'started' || this.props.paymentStatus === 'awaiting_confirmation'}
                                validateEmail={this.props.validateEmail}
                                scrollToEmail={this.props.scrollToEmail}
                                updateEmail={this.props.updateEmail}
                            />
                        </CardContent>
                    </Card>
                }
                {this.props.paymentMethods?.includes('p24_blik') &&
                    <Card className={classNames(classes.root, className)}>
                        <CardContent>
                            <Przelewy24Form
                                blik={true}
                                logo={blik_logo}
                                submitUrl={this.props.przelewy24SubmitUrl}
                                disabled={this.props.disabled || this.state === 'started' || this.props.paymentStatus === 'awaiting_confirmation'}
                                validateEmail={this.props.validateEmail}
                                scrollToEmail={this.props.scrollToEmail}
                                updateEmail={this.props.updateEmail}
                            />
                        </CardContent>
                    </Card>
                }
                {this.props.paymentMethods?.includes('p24') &&
                    <Card className={classNames(classes.root, className)}>
                        <CardContent>
                            <Przelewy24Form
                                blik={false}
                                logo={p24_logo}
                                submitUrl={this.props.przelewy24SubmitUrl}
                                disabled={this.props.disabled || this.state === 'started' || this.props.paymentStatus === 'awaiting_confirmation'}
                                validateEmail={this.props.validateEmail}
                                scrollToEmail={this.props.scrollToEmail}
                                updateEmail={this.props.updateEmail}
                            />
                        </CardContent>
                    </Card>
                }
                {this.props.paymentMethods?.includes('paypal') &&
                    <Card className={classNames(classes.root, className)}>
                        <CardContent>
                            <Przelewy24Form
                                blik={false}
                                logo={paypal_logo}
                                submitUrl={this.props.przelewy24SubmitUrl}
                                disabled={this.props.disabled || this.state === 'started' || this.props.paymentStatus === 'awaiting_confirmation'}
                                validateEmail={this.props.validateEmail}
                                scrollToEmail={this.props.scrollToEmail}
                                updateEmail={this.props.updateEmail}
                            />
                        </CardContent>
                    </Card>
                }
                {this.state.btToken !== null && this.props.paymentMethods?.includes('braintree') &&
                    <Card className={classNames(classes.root, className)}>
                        <CardContent>
                            <BraintreeDropin
                                locale={this.state.language}
                                paymentOptionPriority={['card','googlePay']}
                                googlePay={this.getGooglePayOptions()}
                                renderSubmitButton={this.renderSubmitButton(t)}
                                handlePaymentMethod={(method) => {
                                    ReactGA.event({
                                        category: 'Payment',
                                        action: 'started',
                                        label: 'braintree'
                                    });

                                    this.setState({state: 'processing'});

                                    const that = this;

                                    // Update email before payment
                                    this.props.updateEmail(() => {
                                        that.props.handlePaymentMethod(method)
                                    });
                                }}
                                authorizationToken={this.state.btToken}
                                onCreate={() => {
                                    this.setState({state: 'created'});
                                }}
                                onError={(error) => {
                                    this.setState({state: 'error'});
                                    console.log(error);
                                }}/>
                        </CardContent>
                    </Card>
                }
            </div>
        );
    }

    renderSubmitButton = (t) => {
        return ({onClick, isDisabled}) => {
            if (this.state.state !== 'created') {
                return null;
            }
            return (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                        // Check if email is valid
                        if (!this.props.validateEmail()) {
                            this.props.scrollToEmail();
                            return;
                        }

                        this.setState({state: 'started'});
                        onClick(e);
                    }}
                    disabled={isDisabled || this.props.disabled}>{t('buyAndPay')}</Button>
            );
        };
    }


    getBtToken = () => {
        const that = this;
        fetch(this.props.btTokenUrl).then(function (response) {
            return response.json();
        }).then(function (json) {
            that.setState(json);
        });
    }

    componentDidMount() {
        this.getBtToken();
    }

    getGooglePayOptions = () => {
        const merchantId = process.env.REACT_APP_GOOGLE_PAY_MERCHANT_ID;
        const currency = this.props.currency || 'PLN';
        const amount = this.props.amount || 0;
        const formattedAmount = typeof amount === 'number' ? amount.toFixed(2) : amount.toString();

        const options = {
            googlePayVersion: 2,
            transactionInfo: {
                totalPriceStatus: 'FINAL',
                totalPrice: formattedAmount,
                currencyCode: currency
            }
        };
        if (merchantId) {
            options.merchantId = merchantId;
        }

        return options;
    }
}

export default withStyles(styles)(withTranslation()(PaymentForm));
